import { ScriptDef, ScriptTheme } from '../../types';

export const TV_GUZHUANG_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_049',
        name: '鹤归辞',
        genre: 'tv',
        synopsis: '大梁末年，先帝暴毙当夜，中宫皇后亦鸩杀于椒房殿，遗诏失踪。太傅之女沈青梧以太医院女医的身份入宫——她真正的身份，是被构陷谋逆的先太傅遗孤。女医的药箱恰好能走到各宫的病榻前，她以医术为刀、以药理为盾，先查皇后死因，再顺藤摸向十二年前那场宫变，周旋于摄政王萧珩与少帝萧珣之间，却发现所有线索的尽头，都指向垂帘十余年的太后。',
        roles: [
            {
                name: '沈青梧',
                roleType: '女主角',
                billing: 1,
                intro: '太傅遗孤，匿身太医院的女医，精通毒理药理，以柔克刚，暗中布局十余年只为翻案。她的药箱夹层里有一份抄了一半的旧年脉案，抄完之日就是翻案之时。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '萧珩',
                roleType: '男主角',
                billing: 1,
                intro: '先帝胞弟、摄政王，权倾朝野，表面跋扈实则另有隐情，与沈青梧亦敌亦友。她要救的人他拦过，她要查的人他也拦过，拦的从来不是药箱。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '太后',
                roleType: '女配角',
                billing: 3,
                intro: '垂帘听政十余年，皇后的死与太傅的案都有她的影子，手段狠辣却并非全然恶人，是全剧最具灰度的角色。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '裴照',
                roleType: '男配角',
                billing: 4,
                intro: '锦衣卫指挥使，沈青梧之父旧部，暗中守护多年，身份成谜。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 2,
                attributeGrowth: { talent: 2, stamina: 2, temperament: 2 },
            },
            {
                name: '阮枣',
                roleType: '女配角',
                billing: 5,
                intro: '太医院药房小药童，抓药从不出错，师父们斗得天翻地覆，她只管守着戥子。',
                level: 1,
                gender: 'female',
                requirements: [{ attr: 'temperament', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Scheme, ScriptTheme.Female],
        heat: 59,
        baseScore: 6.9,
    },
    {
        id: 'SCRIPT_050',
        name: '半城玉',
        genre: 'tv',
        synopsis: '河东玉商姜家，世代以琢玉为业。家主暴毙，留下一卷残缺的琢玉秘谱与巨额债务。长女姜白璧自幼随父在工坊长大，只习得辨玉之技，未学经营之道。族中长老欲以“女子不可掌家”为由夺产。她索性将秘谱一分为二，一半留在姜家，一半压入当铺，以“半城玉”之名，重开一方玉石生意。一纸玉契，定的是身价，也是人心。',
        roles: [
            {
                name: '姜白璧',
                roleType: '女主角',
                billing: 1,
                intro: '河东姜家长女，自幼随父在工坊长大，一手辨玉的功夫无人能及。父亲暴毙后接掌家业，以“半城玉”字号重开玉石生意。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '温时颂',
                roleType: '男主角',
                billing: 1,
                intro: '西京当铺朝奉，靠估玉起家。他看玉从不走眼，看人却常栽跟头，屡屡在姜白璧的价码上吃亏。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2 },
            },
            {
                name: '苏曼生',
                roleType: '女配角',
                billing: 4,
                intro: '河东盐商之女，姜白璧闺中旧友，亦是玉石行的对家。她羡慕白璧的果决，却始终越不过家里那本账。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '来顺',
                roleType: '男配角',
                billing: 5,
                intro: '当铺灶上的学徒，认不得玉，认得每一位上门客人的鞋。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Female],
        heat: 63,
        baseScore: 7.3,
    },
    {
        id: 'SCRIPT_051',
        name: '进京三阶',
        genre: 'tv',
        synopsis: '建阳乡僻处闽北，地瘠民贫，上官催收的重税却一分不少。乡绅沈一皿为免乡里连坐，独自扛下整村的赋税，累出一身病。其女沈小禾自幼随父习算盘，识字不多，算账却是一把好手。为给父亲续命，她揣着一本旧账册进京，要找户部讨一笔说法；一路讹、一路算，进京时还是白身，出京时已授三阶官身。一个“算”字，牵出半部朝廷的税收烂账。',
        roles: [
            {
                name: '沈小禾',
                roleType: '女主角',
                billing: 1,
                intro: '建阳乡绅沈一皿之女，书读得不多，算盘倒是打得飞快。她揣着旧账册进京讨说法，一路讹一路算，进京时还是白身，出京时已授三阶官身。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'wisdom', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 2, wisdom: 2, temperament: 2 },
            },
            {
                name: '段秋生',
                roleType: '男主角',
                billing: 1,
                intro: '户部小吏，掌管天下税目。他看出来人是来闹事的，却拗不过对方那句“我替你们查出了三百万两的漏税”。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2 },
            },
            {
                name: '蔡云起',
                roleType: '男配角',
                billing: 3,
                intro: '建阳知府，为官本该护一方百姓，却为了往上爬，把乡里的税一压再压。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '顾玉琼',
                roleType: '女配角',
                billing: 4,
                intro: '户部侍郎，管内库账目。她年轻时也如沈小禾一般，为还乡里旧账入仕，最终却一步步活成了自己最讨厌的样子。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 2,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '书吏小宋',
                roleType: '男配角',
                billing: 5,
                intro: '户部廊下誊抄书吏，替小禾搬了三次账册，每次都多搬一箱。',
                level: 1,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Scheme, ScriptTheme.Female],
        heat: 67,
        baseScore: 7.8,
    },
    {
        id: 'SCRIPT_052',
        name: '凤凰台',
        genre: 'tv',
        synopsis: '大梁末年，国势倾颓，龙椅上的幼帝三岁即位。后宫诸妃为争“太后”尊位斗作一团，其中最不起眼的嫔妃谢瑶华，因“无宠无势”，反被逐个推到前台。她顺势而为，一边抚育幼帝，一边清理宫闱，不动声色间将后宫诸妃尽数收编。当外戚与朝臣发现时，这位“无为”的太后，已把一杆秤握在了自己手里。',
        roles: [
            {
                name: '谢瑶华',
                roleType: '女主角',
                billing: 1,
                intro: '宫中嫔妃，无宠无势，反被立为太后。她顺势而为，一边抚育幼帝，一边清理宫闱，不动声色间把后宫诸妃尽数收编。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '幼帝',
                roleType: '男配角',
                billing: 2,
                intro: '三岁即位，朝臣只当他是枚盖章的玉印。谢瑶华教他读书认字，也教他分辨身边谁可信、谁不可信——这两样本事，他学得比谁都快。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 2, charm: 2 },
            },
            {
                name: '崔太后',
                roleType: '女配角',
                billing: 3,
                intro: '先皇后，本最有资格垂帘听政，却因谢瑶华突然上位而步步落空。她不是败在无谋，是败在低估了一个“无宠”之人。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '陆时澍',
                roleType: '男配角',
                billing: 4,
                intro: '内阁首辅，位极人臣。他原以为太后只是个摆设，直到那杆秤落在自己头上，才终于看清了这个女人。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 2,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '云雀',
                roleType: '女配角',
                billing: 5,
                intro: '掖庭拨来的小宫女，记性差胆子大，是谢瑶华药炉边的常客。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Scheme, ScriptTheme.Female],
        heat: 62,
        baseScore: 7.2,
    },
    {
        id: 'SCRIPT_053',
        name: '女户',
        genre: 'tv',
        synopsis: '明弘治年间，江南翰林秦家卷进科场案被抄家，男丁流放，只余一门妇孺守着空宅和债。大小姐秦窈把妆奁换成算盘，先点人再点产：绣坊的活计、书楼里能换粮的书版、管家奶奶压箱底的私房，一样样盘出门道。族叔串通牙行，要贱价买走她们最后的祭田，秦窈捧着田契骑缝章告到府衙。官司了结那天，官府造册，秦家依律立了女户，户主一栏写的是秦窈的名字。',
        roles: [
            {
                name: '秦窈',
                roleType: '女主角',
                billing: 1,
                intro: '大小姐，琴棋书画没学明白，账目盘算无师自通。抄家那夜她把妆奁换成了算盘，立女户那年才十七岁，官差问她丈夫写谁，她说：写我，我没有丈夫。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '何氏',
                roleType: '女二号',
                billing: 2,
                intro: '长嫂，丈夫被押走后一度寻死，被秦窈骂醒。她管浆洗缝补，带着一屋子夫人娘子接了绣庄的活，工钱按件分，谁也不许少。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '秦仲礼',
                roleType: '男配角',
                billing: 3,
                intro: '秦家族叔，抄家风声一落，头一个上门说要替孤儿寡母「掌眼」清产。他算准了妇孺告不赢，没算到田契的骑缝章一早拓在了秦窈手里。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '杏儿',
                roleType: '女配角',
                billing: 5,
                intro: '牙行跑腿小丫头，被叔公派来探祭田的底，倒先把自家身契的价钱打听明白了。',
                level: 1,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 5 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Female, ScriptTheme.Ancient],
        heat: 58,
        baseScore: 7.2,
    },
    {
        id: 'SCRIPT_055',
        name: '千秋策',
        genre: 'tv',
        synopsis: '前朝太傅裴肃在「庚戌之乱」中被诛满门，其受业弟子陆谦改换户籍，以举子身份入翰林院编纂国史。二十年间，他借修撰《历朝本纪》之便，从档案、奏疏与旧臣口述中拼出当年冤案的原貌，又借经筵进讲，把翻案的线索一句句埋进帝王耳中。当他把成稿的本纪呈上金銮殿，当年炮制冤案的当朝首辅，第一次乱了方寸。',
        roles: [
            {
                name: '陆谦',
                roleType: '男主角',
                billing: 1,
                intro: '翰林院修撰，实为前朝太傅裴肃的关门弟子。裴肃在庚戌之乱中满门被诛，陆谦改换户籍，以举子身份入仕，隐于翰林院二十余年。他借修撰《历朝本纪》之便，从档案、奏疏与旧臣口述中拼出当年冤案原貌，再借经筵进讲，把翻案的线索一点一点埋进帝王耳中。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '景隆帝',
                roleType: '男配角',
                billing: 3,
                intro: '当朝天子，十七岁登基，先帝暴毙的真相与他所坐的龙椅牵连一处。他早从陆谦的进讲中听出那桩旧案的分量，却碍于翻案须先牵出自身，始终迟疑不决。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '沈让',
                roleType: '男配角',
                billing: 4,
                intro: '刑部员外郎，与陆谦因复核旧案相识。早年奉命重审裴肃旧案却屡屡受阻，后转而暗中奔走，为陆谦翻案之事赌上了半生仕途。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3, wisdom: 2 },
            },
            {
                name: '裴婉',
                roleType: '女配角',
                billing: 5,
                intro: '前朝太傅裴肃独女，陆谦师妹。庚戌之乱后隐姓埋名，在宫中做浣衣女官，暗中为陆谦传递消息。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 1,
                attributeGrowth: { charm: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Scheme, ScriptTheme.SeriousDrama],
        heat: 76,
        baseScore: 9.3,
    },
    {
        id: 'SCRIPT_056',
        name: '清浊录',
        genre: 'tv',
        synopsis: '崇宁年间，国库空虚，边患不断。户部尚书魏九章执掌漕务二十余年，漕运上下的人事没一样绕得过他家门墙。清流出身的右都御史宁拙领钦差南下查办漕银亏空，却发现每一笔烂账背后，都连着京中某位他得罪不起的人。查案查到走投无路时，他把追出的烂账绘成一幅《漕河清丈图》，每段淤废的河道旁都注着经手人的名字。图呈上去，御笔只圈了一个圈——圈住的，正是那个谁都不敢写在纸上的字。',
        roles: [
            {
                name: '宁拙',
                roleType: '男主角',
                billing: 1,
                intro: '右都御史，历任户科给事中、大理寺少卿，以清介著称。被委以彻查漕银亏空的重任，领钦差南下。查案不靠供词，只翻旧账本，三个月后带回国都的，是一箱无人敢看的转运流水。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '崇宁帝',
                roleType: '男配角',
                billing: 3,
                intro: '当朝天子，深知国库亏空之重，却碍于窟窿背后牵连宠臣，屡屡按下彻查的念头。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '顾瓒',
                roleType: '男配角',
                billing: 4,
                intro: '河道总督，魏九章门生，宁拙故交。夹在两任恩主之间，既不愿背师恩，又不愿做贪官的伥鬼，处处进退两难。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '柳三娘',
                roleType: '女配角',
                billing: 5,
                intro: '扬州城内“柳叶渡”码头的老板娘，消息灵通，八面玲珑。宁拙南下查案，几处关键的账目线索，都是从她这处渡口打听来的。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'talent', value: 15 },
                ],
                shootWeeks: 1,
                attributeGrowth: { temperament: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Scheme, ScriptTheme.SeriousDrama],
        heat: 72,
        baseScore: 8.8,
    },
    {
        id: 'SCRIPT_057',
        name: '棋帷',
        genre: 'tv',
        synopsis: '幼主登基，太后垂帘，两位顾命大臣一主朝堂、一领边军，明里辅政，暗里各立山头。边关归来的少将军谢宣，原只想替战死的兄长扶柩还乡，却因手握兄长留下的半块兵符，成了两派争抢的棋子。他索性谁也不投，以兵符为棋，逼两派自己下场厮杀。',
        roles: [
            {
                name: '谢宣',
                roleType: '男主角',
                billing: 1,
                intro: '将门之后，年少封侯，久镇边关。因兄长战死，扶柩还乡，意外得兄长遗下之半块兵符，遂成两党争抢的棋子。他不肯低头投靠任何一方，反以兵符为棋，逼两派自己下场厮杀。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'stamina', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, stamina: 2, wisdom: 2 },
            },
            {
                name: '裴敬',
                roleType: '男二号',
                billing: 2,
                intro: '内阁首辅，人称「裴而不露」，以曲意藏锋著称。为拉拢谢宣，先从谢家旧宅的地契下手。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '沈国公',
                roleType: '男配角',
                billing: 3,
                intro: '掌兵部，行伍半生，性如点兵。见谢宣不肯低头，直言相胁，欲以势压人。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'stamina', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, stamina: 2 },
            },
            {
                name: '谢徽',
                roleType: '女配角',
                billing: 3,
                intro: '谢宣胞妹，将门出身，自幼随兄在边军校场长大。兄长扶柩离边，她代掌谢家旧部的家兵名册——两派抢兵符抢得刀刀见血，却都还没想起名册的另一半在她手里。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'stamina', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { stamina: 2, temperament: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Scheme, ScriptTheme.SeriousDrama],
        heat: 63,
        baseScore: 7.7,
    },
    {
        id: 'SCRIPT_058',
        name: '君心',
        genre: 'tv',
        synopsis: '太子容衍监国二十载，仁厚之名满朝皆知。然皇帝龙体渐衰，猜忌日盛，一纸来历不明的密信，令父子从此反目。太子为证清白，先是自请戍边，又于边关「遇刺」假死，暗中潜回京城清查真相。当他层层剥开线索，才发现那封密信竟出自东宫一个不起眼的洒扫宦官之手，而藏在最后的主使，指向了所有人都意想不到的那个人。',
        roles: [
            {
                name: '容衍',
                roleType: '男主角',
                billing: 1,
                intro: '东宫太子，监国二十载，仁厚之名满朝皆知。因一封来历不明的密信遭父皇猜忌，父子反目。为证清白，他先自请戍边，又于边关「遇刺」假死，暗中潜回京城清查真相。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '阿福',
                roleType: '男配角',
                billing: 3,
                intro: '东宫洒扫宦官，十三岁入宫，素不为人所重。那封搅动天下的密信，正是经他之手递入宫中。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '容彻',
                roleType: '男配角',
                billing: 4,
                intro: '二皇子，就藩三年被父皇留在京里，成了摆出来给太子看的一面镜子。他自己只求早回封地，行事滴水不漏，却小看了身边那个端茶送水的奴才。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 2,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '姜昭宁',
                roleType: '女配角',
                billing: 4,
                intro: '都察院御史之女，父亲死于太子案连坐。她变卖家产捐了个女官身份，专为递状鸣冤——满朝都当太子死了，只有她一状一状地告，逼着这桩案子不许翻篇。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'wisdom', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, wisdom: 2, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Scheme, ScriptTheme.SeriousDrama],
        heat: 50,
        baseScore: 6.1,
    },
    {
        id: 'SCRIPT_059',
        name: '沉香引',
        genre: 'tv',
        synopsis: '景和三年新帝登基，中宫沈皇后母族势大，贵妃萧氏倚仗军功家族分庭抗礼。皇后从民间画院选女画师沈令徽入宫，以画像为名在后宫安插耳目。沈令徽入宫后发现，沉香阁里住着的四个女人各有各的活法——皇后护着中宫的体面，贵妃盯着怀里的皇子，太妃只求清静，老宫女数着出宫的日子。一幅画像还没画完，前朝后宫的旧账已经翻了三遍。',
        roles: [
            {
                name: '沈令徽',
                roleType: '女主角',
                billing: 1,
                intro: '画院女画师，因一幅画像被皇后召入宫中。在沉香阁替后宫女眷画行乐图，一幅画要坐足两个时辰，谁的悲喜都藏不进画里去。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '萧贵妃',
                roleType: '女二号',
                billing: 2,
                intro: '倚仗军功家族分庭抗礼的贵妃，育有皇子。她与皇后斗了多年，却不许娘家兵权再进一步——她比谁都清楚，儿子坐上那个位置那天，就是萧家该倒的时候。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, charm: 2 },
            },
            {
                name: '皇后高氏',
                roleType: '女配角',
                billing: 3,
                intro: '中宫皇后，母族势大。她选女画师入宫安插耳目，画的是行乐图，收的是人心。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '陆婉清',
                roleType: '女配角',
                billing: 4,
                intro: '皇后身边的大宫女，管着后宫的月例分配。皇后最信她，她也替皇后做了最多不能摆在台面上的事。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'wisdom', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, wisdom: 2, charm: 2 },
            },
            {
                name: '青桐',
                roleType: '女配角',
                billing: 5,
                intro: '沉香阁的低阶宫女，每天替姐姐们清点绣线、研磨颜料。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Court, ScriptTheme.Scheme],
        heat: 73,
        baseScore: 8.7,
    },
    {
        id: 'SCRIPT_060',
        name: '折桂令',
        genre: 'tv',
        synopsis: '女官之女陆鸢的父亲陆明远因一桩织造贪墨案被冤杀。陆鸢改名入宫，进入尚仪局做女史，一边替宫中女眷记录礼仪事务，一边暗中追查父亲的案子。她发现父亲案的线索牵涉内廷织造局、起居注和当朝贵妃三方势力。陆鸢选择依附权势最大的裴贵妃，一步一步把关键证人推到台面上，最后在大朝会上拿出完整证据链翻案。',
        roles: [
            {
                name: '陆鸢',
                roleType: '女主角',
                billing: 1,
                intro: '女官之女，父亲遭冤杀后改名进宫。在尚仪局做女史，经手的物资账册记得比谁都细，为的就是有朝一日能翻案。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '裴贵妃',
                roleType: '女二号',
                billing: 2,
                intro: '宫中最得宠的妃子，入宫十五年无人能及。表面冷艳跋扈，跋扈是她护住自己和儿子的方式。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, charm: 2 },
            },
            {
                name: '谢长庚',
                roleType: '男配角',
                billing: 2,
                intro: '起居郎，负责记录皇帝一言一行。笔稳口紧，从不主动开口，陆鸢需要的东西偏偏都在他笔底下。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '沈玉娘',
                roleType: '女配角',
                billing: 3,
                intro: '内廷织造局管事，管了二十年宫里的衣料。谁得宠谁失宠她看得最准，陆鸢第一次求她时她只让陆鸢看了一匹布的走向。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '三宝',
                roleType: '男配角',
                billing: 5,
                intro: '尚仪局打杂的小内侍，每天替姐姐们送请帖，从不问送给谁，谁的帖子被退回来他记得最清楚。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Court, ScriptTheme.Scheme],
        heat: 68,
        baseScore: 8.1,
    },
    {
        id: 'SCRIPT_062',
        name: '醒木',
        genre: 'tv',
        synopsis: '绍兴和议之后，临安瓦舍勾栏夜夜笙歌。丰乐楼旁的老茶馆里，说书人老铁嘴一把醒木一块绢，说的全是几十年前北地的旧事：宗泽三呼过河、韩世忠黄天荡、梁夫人擂鼓。朝廷新下禁令，说北事者杖一百，老铁嘴的书目被官差划掉了大半。最后一场书，他说的不是名将，是当年守汴梁的一个没有名字的门军。此后醒木传给了天天蹭书的孤儿狗剩。',
        roles: [
            {
                name: '付一刀',
                roleType: '男二号',
                billing: 2,
                intro: '书里出场次数最多的独眼刀客，原型是老铁嘴当年在河北义军里的弟兄。本人从没听过自己的故事，在茶馆外听了一次自己的下场，听完把刀卖了，改行押镖。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, stamina: 3, temperament: 2 },
            },
            {
                name: '燕红绡',
                roleType: '女配角',
                billing: 2,
                intro: '书中阵前倒戈的女将，依北地旧事所演。她那一回书一年只说一次，一说就有满堂的老人从头哭到尾。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'stamina', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 3, temperament: 3, stamina: 2 },
            },
            {
                name: '狗剩',
                roleType: '男配角',
                billing: 3,
                intro: '茶馆打杂的孤儿，靖康遗民的后代，听书三年，认字靠听，整本书目倒背如流。禁书令下来后，他接了老铁嘴的醒木。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '柳月娥',
                roleType: '女配角',
                billing: 5,
                intro: '茶馆隔壁的绣娘，每天收摊前来听一段收场诗，一天不落。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.History, ScriptTheme.Ancient, ScriptTheme.SeriousDrama],
        heat: 50,
        baseScore: 7.7,
    },
    {
        id: 'SCRIPT_063',
        name: '烽堠狼烟',
        genre: 'tv',
        synopsis: '隋末烽堠四起，护粮队正李尽贯带着一群饿汉抢了官仓放粮，扯旗聚义，渐渐成了十八路反王里的一路。结义兄弟郑天虎、宇文砚各领一军，势力大了，盟里就生了缝。洛口大败之后，三兄弟各走各路：一个受招安，一个守旧寨，一个带着残部南投。多年后说书人的醒木拍到这一段，当年抢仓放粮的那群人，只剩下两个半名字。',
        roles: [
            {
                name: '李尽贯',
                roleType: '男主角',
                billing: 1,
                intro: '护粮队正出身的义军头领，不识字，抢仓放粮之后才学会写自己的名字。他打仗靠兄弟性命堆出来的信义，旗号大了也仍跟老队正在一个棚里吃饭。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'stamina', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, stamina: 2, wisdom: 2 },
            },
            {
                name: '郑天虎',
                roleType: '男二号',
                billing: 2,
                intro: '铁匠出身，李尽贯的结义大哥，使一杆八十斤的铁槊，是盟里第一个反对外人进中军的。盟裂时他第一个受招安，走的那天把铁槊留在了旧寨。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { stamina: 2, talent: 2, temperament: 2 },
            },
            {
                name: '宇文砚',
                roleType: '男配角',
                billing: 3,
                intro: '破落户出身的年轻将领，盟里读书最多的人，文书檄文都出自他手。洛口败后他带残部南投，檄文一路写到了最后。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'wisdom', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { wisdom: 2, talent: 2, temperament: 2 },
            },
            {
                name: '耿十娘',
                roleType: '女配角',
                billing: 3,
                intro: '义军灶上的妇人，全盟各营的口味她都记得。三兄弟的兵马互相动了刀，也只有她的灶棚谁都还肯进。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '王小溜',
                roleType: '男配角',
                billing: 5,
                intro: '义军马倌，每天在各营之间牵马传信，谁家将军的马有什么蹄病他都清楚。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'temperament', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { temperament: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.History, ScriptTheme.War, ScriptTheme.Ancient],
        heat: 53,
        baseScore: 8.1,
    },
    {
        id: 'SCRIPT_064',
        name: '雪围城',
        genre: 'tv',
        synopsis: '初冬，辽军绕过大关直抵古定城下，四门断绝。城中守军三千、军户万余，老旧都监霍无咎与儿子霍延卿父子守城待援。四十天，从粮尽到杀马，军户的寡妇们扛粮上城，十五岁的铁豆接过父亲的腰牌站上了城头。第四十一日，援军的烟尘出现在地平线上，城头点卯，应到的人少了大半。',
        roles: [
            {
                name: '霍延卿',
                roleType: '男主角',
                billing: 1,
                intro: '古定城守军年轻都监，生在城头长在城头，听得出城下的马蹄是来送粮的还是来劫营的。围城四十天，他从只会拼杀的愣头青长成能独当一面的人。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '秦若兰',
                roleType: '女配角',
                billing: 2,
                intro: '军医遗孀，带着一队军户妇人扛粮上城、烧水救伤。药断了之后，她带着人熬雪水给伤员清创，一夜没断过。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '铁豆',
                roleType: '男配角',
                billing: 3,
                intro: '军户少年，父亲战死在围城第十日的城头，他接过父亲的腰牌进了运输队。援军进城那天点卯，他是应到名单里年纪最小的。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, talent: 2 },
            },
            {
                name: '孙卯',
                roleType: '男配角',
                billing: 5,
                intro: '城里的挑水夫，每天往城头挑水。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'stamina', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.History, ScriptTheme.War, ScriptTheme.SeriousDrama],
        heat: 43,
        baseScore: 7.3,
    },
    {
        id: 'SCRIPT_065',
        name: '武魁',
        genre: 'tv',
        synopsis: '隋末唐初，突厥连年南下。少年将军楚云翊在旧武库得一杆前朝遗枪“龙渊”，坊间传说枪里封着战魂。他与突厥和亲使团里的圣女华初霁相恋，而圣女受使命所限终身不得嫁人。华初霁被掳往王庭，楚云翊单枪匹马闯营，一枪震退十万控弦。此后每逢大战，枪魂都会显灵扭转战局，圣女则以血续封印。渭水之盟的使帐外，华初霁耗尽精血解开龙渊枪的终极封印，楚云翊一枪斩落敌酋，抱着圣女在漫天花雨中许下三生之约。',
        roles: [
            {
                name: '楚云翊',
                roleType: '男主角',
                billing: 1,
                intro: '将门遗孤，少年将军，凭祖传神枪“龙渊”一战成名。他与圣女华初霁情定于两军阵前，此后枪魂显灵的每一场大战，她都在城头为他续上封印。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { charm: 3, stamina: 3, temperament: 2 },
            },
            {
                name: '华初霁',
                roleType: '女主角',
                billing: 2,
                intro: '和亲使团里的守护圣女，白衣胜雪，受使命所限终身不得嫁人。她的眼泪能续上龙渊枪的封印，每为楚云翊落一次泪，枪魂便强一分，她的性命便弱一分。',
                // 2026-09-30 用户拍板：女主降为二番（原与男二番拔野同为 Lv.5、同拿 15 万＝一二番撞平，改由番位差消解）。
                // roleType 保持「女主角」——AwardSystem.deriveTier 只看 roleType 含不含「主角」、不看 billing，
                // 故她仍走 lead 档提名女主角奖（先例＝《合租许可证》《她的房间》《深空回声》《酒过三巡》《柳叶刀》
                // 这 5 本的女主角位同样挂二番；原列《三餐四季》已于 2026-10-02 按新群像口径「同性别 ≥3」升回一番）。level / requirements / attributeGrowth / shootWeeks 一律不动（片酬仍 15 万）；
                // billing 1→2 的真实效果＝番位系数 1.0→0.7（名气滴灌总额与评分罚/奖同乘）＋剧宣蹭剧权重 1.0→0.6。
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 8,
                attributeGrowth: { charm: 2, temperament: 2, talent: 2 },
            },
            {
                name: '拔野',
                roleType: '男二号',
                billing: 2,
                intro: '突厥可汗，弯刀纵横草原，倾国之兵只为夺取神器。他坚信神器认主是传言，人强才是真的，故每次交手都弃阵法以力破之，偏不信那一枪。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 2, stamina: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Fantasy, ScriptTheme.Romance],
        heat: 40,
        baseScore: 4.5,
    },
    {
        id: 'SCRIPT_069',
        name: '青崖小妖传',
        genre: 'tv',
        synopsis: '青崖山脚，修习半吊子御剑术的散修陈无咎，接了一单「斩妖」的活，下山才知那妖是只五百年道行、只会偷鸡摸狗的小狐妖白青崖。他下不去手，索性带着这妖上路，一路又结识了爱钱的捉妖师、失忆的刀客、满嘴卦象的道姑，本只想混口饭吃，最后却撞进了「天门将开、青崖封妖古碑一夜褪字」的那场大祸里。等祸事平定，有人成了仙，有人留在了人间。',
        roles: [
            {
                name: '陈无咎',
                roleType: '男主角',
                billing: 1,
                intro: '青崖山半吊子散修，御剑只能离地三尺，靠着接斩妖散单糊口。嘴硬心软，最见不得小妖下跪求饶。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'charm', value: 55 },
                    { attr: 'stamina', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, charm: 3, stamina: 2, wisdom: 2 },
            },
            {
                name: '白青崖',
                roleType: '女主角',
                billing: 1,
                intro: '五百年道行的小狐妖，只偷鸡不伤人，梦想是攒够功德早日化形。被陈无咎捡到那天，是她这五百年里最倒霉也最走运的一天。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 60 },
                    { attr: 'talent', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { charm: 3, talent: 3, temperament: 2, wisdom: 2 },
            },
            {
                name: '阴无期',
                roleType: '男二号',
                billing: 2,
                intro: '只认钱的捉妖师，一单捉妖收费绝不还价，唯独对陈无咎身边这只小妖网开一面。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 45 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, charm: 3, talent: 2 },
            },
            {
                name: '顾衔霜',
                roleType: '女二号',
                billing: 2,
                intro: '满嘴卦象、算无遗策的道姑，实为封妖古碑褪字的推手。她等天门开，等了整整三百年。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, wisdom: 3, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Xianxia],
        heat: 72,
        baseScore: 7.9,
    },
    {
        id: 'SCRIPT_070',
        name: '遇雪行',
        genre: 'tv',
        synopsis: '边城少年顾青峰替亡兄送信入京，风雪封道，误入江湖第一把交椅的铁衣盟试剑大会。他凭家传刀法连闯三关，却目睹掌门血溅当场——门外引路的暗号，恰与兄长的遗书严丝合缝。官府通缉，仇家追杀，他只得与盗剑的少女、押黄金镖的唐门弟子结伴同行，一路往铁衣盟赶，去查一桩十年前的旧案。',
        roles: [
            {
                name: '顾青峰',
                roleType: '男主角',
                billing: 1,
                intro: '边城兵户之子，随兄习刀，传家十三式「关山刀」。替亡兄送信入京，误入铁衣盟试剑大会，凭刀法连闯三关，又成了掌门被杀时唯一的目击证人。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'stamina', value: 55 },
                    { attr: 'charm', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, stamina: 3, charm: 2, wisdom: 2 },
            },
            {
                name: '符羽',
                roleType: '女主角',
                billing: 1,
                intro: '铁衣盟弃徒，偷走了盟里那把「断雁刀」。她比谁都清楚试剑大会上那一刀是谁砍的，只是没人在意一个弃徒的话。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'stamina', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, stamina: 3, temperament: 2, wisdom: 2 },
            },
            {
                name: '唐临风',
                roleType: '男二号',
                billing: 2,
                intro: '唐门弟子，押一口黄金镖误入是非。镖箱里装的东西，与那桩血案出自同一处。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 2, stamina: 2, temperament: 2 },
            },
            {
                name: '燕达',
                roleType: '男配角',
                billing: 3,
                intro: '铁衣盟长老，主持试剑大会。他掀开掌门尸体时手很稳，可落在地上的半枚断箭，分明是自己的暗器。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.MartialArts, ScriptTheme.Mystery],
        heat: 63,
        baseScore: 8.2,
    },
    {
        id: 'SCRIPT_071',
        name: '夜行长安',
        genre: 'tv',
        synopsis: '贞元年间，长安屡有百姓夜半不归。大理寺司直沈越巡夜，接连经手三桩怪案：夜枭叼人、旱魃借尸、胡商驼队僵立道旁。他请来屡试不第、专治志怪杂学的书生褚正衣搭手，一个按律令断案，一个照野史推凶，竟从三桩泼天怪谈里，锁到了同一只手上——藏在「夜半敲更人」里的一张旧脸。',
        roles: [
            {
                name: '沈越',
                roleType: '男主角',
                billing: 1,
                intro: '大理寺司直，办案只认律令证据，不认鬼神。三桩案子都被他办成铁案，同僚反骂他「把鬼事当人事办」。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '褚正衣',
                roleType: '男主角',
                billing: 1,
                intro: '屡试不第的书生，自嘲「读了一肚子野史」。通志怪、识巫蛊，上不了朝堂，混迹市井替人看风水糊口。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '广丰',
                roleType: '男配角',
                billing: 3,
                intro: '金吾卫旅帅，沈越多年的老搭档。不识字，认脚印、认气味，办案全靠一双眼睛。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'wisdom', value: 35 },
                    { attr: 'stamina', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, wisdom: 2, stamina: 2 },
            },
            {
                name: '程莺',
                roleType: '女配角',
                billing: 3,
                intro: '官府登记在册的女仵作，专验女尸。三桩怪案的死者有两名女性，她验出的伤口角度、指甲里的粉末，和男仵作的记录对不上——没人问她为什么。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'wisdom', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, wisdom: 2, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.MartialArts, ScriptTheme.Mystery],
        heat: 61,
        baseScore: 7.9,
    },
    {
        id: 'SCRIPT_072',
        name: '断蛟渡',
        genre: 'tv',
        synopsis: '汶水十年一涝，是岁蛟渡口河床骤裂，镇河二十八年的「断蛟锁」断作两截，水脉一夜枯绝。掌管河道的河泊所推官沈砚秋被革职查办，他带着唯一的线索——一枚刻着干支的铁环，沿河道往上游追。每一截断锁上，都拴着一桩他没见过的旧案；而断锁的出处，直指下游那座从不对百姓开门的漕运总督府。',
        roles: [
            {
                name: '沈砚秋',
                roleType: '男主角',
                billing: 1,
                intro: '河泊所推官，掌汶水河道二十八载，一卷河图烂熟于胸。断蛟锁断、水脉枯绝，他成了唯一的背锅人，索性带上铁环沿河追凶。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '商鹿鸣',
                roleType: '男主角',
                billing: 1,
                intro: '漕运总督府的账房先生，随身一杆黑幡，专收「添头钱」。他帮着沈砚秋查案，却从不踏进漕运总督府的门。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '沈雁回',
                roleType: '女配角',
                billing: 3,
                intro: '河神祠庙祝，守着汶水上的那口古钟。断锁断裂那夜，她亲眼看见有人摸进了河床。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.MartialArts, ScriptTheme.Mystery],
        heat: 63,
        baseScore: 8.2,
    },
    {
        id: 'SCRIPT_073',
        name: '夜航七客',
        genre: 'tv',
        synopsis: '元和年间北境用兵，随军运粮的少年火头军孙九郎，在一场溃退里与大部队走散，只与另外六个互不相识的散兵游勇挤上一条夜航船。船行三夜，白日里先后有两名同行者横死船舱。七人各怀旧事，彼此试探，孙九郎靠着一手记军账的功夫，一点点把六人的来路和死者的死因对到一起。等船靠岸，岸边等着他们的，是一场没人认领的胜仗。',
        roles: [
            {
                name: '孙九郎',
                roleType: '男主角',
                billing: 1,
                intro: '随军火头军，做的一手好饭，还能把全营军账记个分毫不差。溃退时与大军失散，上了那条夜航船。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2 },
            },
            {
                name: '秦放',
                roleType: '男二号',
                billing: 2,
                intro: '溃军里脱了甲胄的百夫长，一身伤，却执意要把剩下的兄弟带回去。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { talent: 2, stamina: 2, temperament: 2 },
            },
            {
                name: '陆英',
                roleType: '女配角',
                billing: 3,
                intro: '随军医师，背着一箱金疮药上船。船上最先死的那个，正是她昨夜看过诊的病人。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, wisdom: 2 },
            },
            {
                name: '霍重山',
                roleType: '男配角',
                billing: 4,
                intro: '船上的货主，声称此行只为贩茶。他账册上的茶叶，比船吃水线整整重了三百斤。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.MartialArts, ScriptTheme.Mystery],
        heat: 65,
        baseScore: 8.4,
    },
    {
        id: 'SCRIPT_103',  // 低分反面教材·电视剧/低分剧
        name: '玉关辞',
        genre: 'tv',
        synopsis: '四国纷乱之际，越国朔方军统帅陆持钧围陈国都三月，陈国献出目盲的昭影公主和亲求和。大婚当夜王府遇袭，"盲女"引着陆持钧穿过箭雨逃生，他这才发现她的眼里没有一丝盲态——所谓旧疾，是她为躲避夺嫡自囚多年。和亲各有所图：她要借统帅之师回陈，他要用这桩婚事安边。上公主卫长宁在朝中步步紧逼，陈国旧使暗中传信递刀，所有的风云都聚在王府一墙之内。两人最终放下各自的算计，联手平了陈国王庭之乱，换来边关三十年无事。',
        roles: [
            {
                name: '陆持钧',
                roleType: '男主角',
                billing: 1,
                intro: '越国朔方军统帅，连下四十一城，话少面冷。娶陈国公主那日，他命人在王府门前铺了一条十里平路，说她的轿子不能颠。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { charm: 3, temperament: 3, wisdom: 2, talent: 2 },
            },
            {
                name: '阮照影',
                roleType: '女主角',
                billing: 1,
                intro: '陈国嫡公主，幼时"病盲"。通琴理、熟地理，听风便知水性。嫁入越国后，是王府里唯一敢当面驳朔方军统帅的人。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { charm: 3, temperament: 3, wisdom: 2, talent: 2 },
            },
            {
                name: '卫长宁',
                roleType: '女二号',
                billing: 2,
                intro: '越国上公主，代帝掌钱监与边贸马市。她有自己的储君人选，把这桩和亲当作棋盘上最好落的一子。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { charm: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '裴执',
                roleType: '男二号',
                billing: 2,
                intro: '陈国使馆随驾学生，化名潜入王府做了门客。他是世上唯一知道公主病情始末的旧臣，进了王府之后，使馆的名册上还挂着他的名字。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'wisdom', value: 35 },
                    { attr: 'stamina', value: 30 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 2, wisdom: 2, stamina: 2 },
            },
            {
                name: '阿螺',
                roleType: '女配角',
                billing: 5,
                intro: '王府掌灯宫女，夜里按更次把廊下灯一盏盏点过去，从不在主子跟前抬头。',
                level: 2,
                gender: 'female',
                requirements: [{ attr: 'charm', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Scheme, ScriptTheme.Romance],
        heat: 27,
        baseScore: 3.4,
    },
    {
        id: 'SCRIPT_105',  // 低分反面教材·电视剧/低分剧
        name: '疏川记',
        genre: 'tv',
        synopsis: '上古九河泛滥，水患不治，天庭封水族于穷山之下，命人间河官世代守堤。巡河之子虞见潮在堤溃那夜从水里捞出一个能与水对话的姑娘池含霜，也知道了她体内沉睡着水族最后的心脏。族老说，治水必须诛龙；天下说，爱她便是负天下。他两头都选了：以手疏九河入海，以肩背她入穷山深处，把心还给水族，把一世河清换给人间。',
        roles: [
            {
                name: '虞见潮',
                roleType: '男主角',
                billing: 1,
                intro: '巡河世家独子，隔百里听得见堤身渗水声，堤溃当夜是他腰上拴着绳跳进漩涡的。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 60 },
                    { attr: 'stamina', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { charm: 3, stamina: 3, wisdom: 2, talent: 2 },
            },
            {
                name: '池含霜',
                roleType: '女主角',
                billing: 1,
                intro: '从江上捞来的姑娘，记忆停在穷山崩裂那年。手心贴在水面上，浪会先自己安静下来。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 8,
                attributeGrowth: { charm: 3, temperament: 3, wisdom: 2, talent: 2 },
            },
            {
                name: '和有鱼',
                roleType: '男二号',
                billing: 2,
                intro: '都水使之子、河警都头，喊船号带着军令的口气。父亲葬在九河里，未完成的治水图收在他自己怀里。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 6,
                attributeGrowth: { temperament: 3, stamina: 3, wisdom: 2 },
            },
            {
                name: '费景',
                roleType: '女配角',
                billing: 3,
                intro: '河督之女，男主的指腹为婚，编堤草绳时能背出他所有的小名，备嫁的茶摆了三个春天。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 2, temperament: 2, wisdom: 2 },
            },
            {
                name: '老甘',
                roleType: '男配角',
                billing: 5,
                intro: '修堤料场的守夜人，替每一车石灰点灯记账，知道九河哪一段堤身踩上去最虚。',
                level: 2,
                gender: 'male',
                requirements: [{ attr: 'stamina', value: 12 }],
                shootWeeks: 1,
                attributeGrowth: { stamina: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Fantasy, ScriptTheme.Romance],
        heat: 29,
        baseScore: 3.6,
    },
    {
        // 特殊剧本（定时上架型）内容本体：附表见 tables/SpecialScripts.ts（2026-10-06，数值暂定待茄子手调）
        id: 'SCRIPT_902',
        name: '承天',
        genre: 'tv',
        // shootMonths override：roles 无一番位（一番女主萧燕燕在 cast），剧级档期无法派生，
        // 显式 4 个月（影后大制作体量）；已登记导入台账 override 清单。
        shootMonths: 4,
        synopsis: '辽景宗病重的几年，各地奏章都由皇后萧燕燕代批。景宗驾崩，三十岁的她抱着十二岁的儿子坐上摄政太后的位子，宗王环伺，主少国疑。她靠韩德让和几位老臣稳住朝局，练兵、劝农、修法，四十九岁那年亲率大军南下，在澶州城下与宋朝订下百年盟约。',
        roles: [
            {
                name: '韩德让',
                roleType: '男主角',
                billing: 2,
                intro: '汉人重臣之子，太后的股肱，少年时与她一起在马背上长大。满朝都盯着他跟太后的闲话，他索性常年住在北院军中。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 55 },
                    { attr: 'temperament', value: 50 },
                ],
                shootWeeks: 12,
                attributeGrowth: { talent: 3, temperament: 2 },
            },
            {
                name: '萧胡辇',
                roleType: '女配角',
                billing: 3,
                intro: '太后的大姐，皇太妃，自己领着一路兵马镇在西北。她觉得妹妹给汉人让的路太多，姐妹俩隔着千里通信，每一封都像国书。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 2, temperament: 2, charm: 1 },
            },
            {
                name: '苏合',
                roleType: '女配角',
                billing: 4,
                intro: '太后帐下掌香药的年轻女官，跟着去过宋营议和。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 30 },
                    { attr: 'temperament', value: 20 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, temperament: 2 },
            },
            {
                name: '耶律斜轸',
                roleType: '男配角',
                billing: 3,
                intro: '北院大将，主战派里嗓门最大的一个。年轻时求娶过萧燕燕，后来她进了宫，这事他再没提过。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 50 },
                    { attr: 'talent', value: 45 },
                ],
                shootWeeks: 8,
                attributeGrowth: { stamina: 3, talent: 2 },
            },
        ],
        // 固定阵容：name=剧中角色名，npcId=演员（庄文茵）；roleType 供奖项档位/性别派生
        cast: [{ name: '萧燕燕', billing: 1, npcId: 'npc_zhuangwenyin', roleType: '女主角' }],
        relatedNPCs: ['npc_zhuangwenyin'],
        themes: [ScriptTheme.History, ScriptTheme.Female, ScriptTheme.War],
        heat: 60,
        baseScore: 6.6,
    },
    {
        // 特殊剧本（剧情解锁型）内容本体：附表见 tables/SpecialScripts.ts（2026-10-06，数值暂定待茄子手调）
        id: 'SCRIPT_904',
        name: '十二阶',
        genre: 'tv',
        synopsis: '户部小吏之女江照宁因父亲替东家顶了内库亏空的罪名，没入浣衣局为奴。替掌事对账时，她把当年内库那桩案子的窟窿对出了轮廓——顶罪的是她父亲，真账却不知去向。也正是这本账，让年轻的皇帝注意到了她。她看得出这位天子对她是什么意思，也想明白了一件事：这宫里能替她翻案的，只有他。她顺着这层意思走进后宫。宫女到凤座，隔着十二阶：答应、贵人、嫔、妃，每晋一阶都要过一道坎，也离真相近一步。十二阶走完，她站到了能翻案的地方。',
        roles: [
            {
                name: '江照宁',
                roleType: '女主角',
                billing: 1,
                intro: '户部小吏之女，父罪没官，在浣衣局为奴也没磨掉的硬脾气——受了欺负当场就还，从没让人讨了好去。替掌事对账时，对出了父亲那桩案子的不对劲。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 45 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 2, temperament: 2, eq: 1 },
            },
            {
                name: '容煜',
                roleType: '男主角',
                billing: 1,
                intro: '年轻的帝王，登基第三年，前朝还在太后手里。内库亏空案他压了三年不敢动，直到江照宁把账目送到了他面前。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 45 },
                    { attr: 'temperament', value: 40 },
                    { attr: 'charm', value: 35 },
                ],
                shootWeeks: 8,
                attributeGrowth: { talent: 2, temperament: 2, charm: 1 },
            },
            {
                name: '崔琬琬',
                roleType: '女二号',
                billing: 2,
                intro: '户部尚书的嫡女，考选入宫的女官，掌文书账目。崔家在朝堂上败象已露，她进宫当差，是想把家里最后那点余温攥成实权。后来家族倒了，她出宫自请替公主和亲，拿自己换家族退路。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 2, temperament: 2, wisdom: 1 },
            },
            {
                name: '沈知白',
                roleType: '男配角',
                billing: 2,
                intro: '御前侍卫，查内库旧案时与江照宁搭过一次手。此后她那边一有动静，他总能"恰好"巡到附近。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'stamina', value: 40 },
                    { attr: 'talent', value: 35 },
                ],
                shootWeeks: 5,
                attributeGrowth: { stamina: 3, talent: 2 },
            },
        ],
        relatedNPCs: ['npc_muyao'],
        themes: [ScriptTheme.Court, ScriptTheme.Scheme, ScriptTheme.Female],
        heat: 51,
        baseScore: 7.3,
    },
];
